export default __webpack_public_path__ + "static/media/about-show-pic2.0f92e40f.jpeg";